import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Sparkles, Loader2 } from "lucide-react";
import EventBooking from "@/components/EventBooking";
import CTASection from "@/components/CTASection";
import NewsletterSection from "@/components/NewsletterSection";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const MiniShoots = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/events`)
      .then(({ data }) => setEvents(data))
      .catch(() => setEvents([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <section className="relative pt-40 md:pt-48 pb-16 bg-ink text-white overflow-hidden">
        <div className="absolute inset-0 opacity-[0.07] bg-[radial-gradient(circle_at_20%_20%,#C89B5C_0,transparent_55%)]" />
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="container-x relative max-w-3xl"
        >
          <p className="eyebrow text-gold mb-4">Tijdelijke mini-shoots</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
            Korte sessies, <span className="italic text-gold">grote herinneringen.</span>
          </h1>
          <p className="mt-7 text-white/70 leading-relaxed text-base md:text-lg">
            Een paar keer per jaar zet ik mijn agenda open voor tijdelijke mini-shoots — kerst,
            halloween, lentefeest. Kort, sfeervol en scherp geprijsd. Kies een dag, kies je uur,
            reken direct af en je plekje staat vast.
          </p>
        </motion.div>
      </section>

      <section className="bg-white py-20 md:py-28" data-testid="mini-shoots-page">
        <div className="container-x">
          {loading ? (
            <p className="inline-flex items-center gap-2 text-neutral-500 text-sm">
              <Loader2 size={15} className="animate-spin" /> Sessies laden...
            </p>
          ) : events.length === 0 ? (
            <div
              className="max-w-xl mx-auto text-center border border-dashed border-neutral-300 p-14"
              data-testid="mini-shoots-empty"
            >
              <Sparkles size={26} className="text-gold mx-auto" strokeWidth={1.3} />
              <p className="font-serif text-3xl mt-6">Momenteel geen actie</p>
              <p className="text-neutral-600 mt-4 leading-relaxed">
                Er loopt nu geen tijdelijke mini-shoot. Schrijf je in op de nieuwsbrief en je bent
                de eerste die de nieuwe data ziet — die plekjes gaan snel.
              </p>
            </div>
          ) : (
            <div className="space-y-28">
              {events.map((ev) => (
                <EventBooking key={ev.id} event={ev} />
              ))}
            </div>
          )}
        </div>
      </section>

      {events.length === 0 && !loading && <NewsletterSection />}
      <CTASection />
    </>
  );
};

export default MiniShoots;
